import { Duration } from 'luxon';

import { DayRange } from '../WidgetBlocks/types';

export default ({ min, max }: DayRange) => {
    const fromRange = Duration.fromObject({ days: min }).toISO();
    const toRange = Duration.fromObject({ days: max }).toISO();
    return `${fromRange}--${toRange}`;
};

interface TimeRange {
    start: Duration;
    end: Duration;
}

const transformTimeRangeToDurations = (timeRange: string): TimeRange => {
    const [start, end] = timeRange.split('--');
    return {
        start: Duration.fromISO(start),
        end: Duration.fromISO(end),
    };
};

const transformTimeRangeToDurationsRemovingBuffer = (timeRange: string, startOfUnit: string): TimeRange => {
    const durationObject = { [startOfUnit]: 1 };
    const bufferValue = Duration.fromObject(durationObject);
    const { start, end } = transformTimeRangeToDurations(timeRange);
    return {
        start: start.plus(bufferValue),
        end: end.minus(bufferValue),
    };
};

const transformTimeRangeToDurationsAddingBuffer = (timeRange: string, startOfUnit: string) => {
    const durationObject = { [startOfUnit]: 1 };
    const bufferValue = Duration.fromObject(durationObject);
    const { start, end } = transformTimeRangeToDurations(timeRange);
    return {
        start: start.minus(bufferValue),
        end: end.plus(bufferValue),
    };
};

const transformDurationsToTimeRange = ({ start, end }: TimeRange): string => `${start.toISO()}--${end.toISO()}`;

const addBufferToTimeRange = (timeRange: string, startOfUnit: string) =>
    transformDurationsToTimeRange(transformTimeRangeToDurationsAddingBuffer(timeRange, startOfUnit));
const removeBufferFromTimeRange = (timeRange: string, startOfUnit: string) =>
    transformDurationsToTimeRange(transformTimeRangeToDurationsRemovingBuffer(timeRange, startOfUnit));
const changeBufferInTimeRange = (timeRange: string, oldStartOfUnit: string, newStartOfUnit: string) =>
    addBufferToTimeRange(removeBufferFromTimeRange(timeRange, oldStartOfUnit), newStartOfUnit);

export {
    transformTimeRangeToDurationsRemovingBuffer,
    transformTimeRangeToDurations,
    transformTimeRangeToDurationsAddingBuffer,
    transformDurationsToTimeRange,
    changeBufferInTimeRange,
    addBufferToTimeRange,
    removeBufferFromTimeRange,
};
